module.exports = __webpack_public_path__ + "d580f78290dac9680901c9ce3fe1432e.jpg";